module.exports = __webpack_public_path__ + "img/maestro.65d111b.png";